import ICalculatorConfiguration from "../../models/ICalculatorConfiguration";
import { ICalculatorInput } from "../../models/ICalculatorInput";

export default function filterDuplexOptions(
  pricingConfiguration: ICalculatorConfiguration,
  calculatorInput: ICalculatorInput,
): { value: boolean; label: string }[] {
  const printingOption =
    pricingConfiguration.pricingConfiguration.printingOptions.filter(
      (po) => po.code === calculatorInput.selectedPrintingOption,
    )[0];

  const duplexOptions = [] as { value: boolean; label: string }[];
  if (!printingOption.requireDuplexMode) {
    duplexOptions.push({ value: false, label: "One Sided" });
  }
  if (
    printingOption.supportsDuplexMode &&
    (calculatorInput.pagesBlack ?? 0) + (calculatorInput.pagesColour ?? 0) > 1
  ) {
    duplexOptions.push({ value: true, label: "Double Sided" });
  }
  return duplexOptions;
}
